import { computed, type ComputedRef } from "vue";
import { hexToRgba } from "../../../utils/html/html";

export interface ShadowProps {
  enabled?: boolean;
  blur?: number;
  offsetX?: number;
  offsetY?: number;
  color?: string;
  opacity?: number;
}

export function useMediaShadow(shadowProps?: ComputedRef<ShadowProps | undefined>) {
  // Генерируем CSS стиль тени (только значение для filter)
  const shadowStyle = computed(() => {
    const shadow = shadowProps?.value;
    if (!shadow || !shadow.enabled) return undefined;

    const { blur, offsetX, offsetY, color, opacity } = shadow;

    const rgbaColor = hexToRgba(color || "#000000", opacity || 0.3);

    return `drop-shadow(${offsetX || 0}px ${offsetY || 4}px ${
      blur || 10
    }px ${rgbaColor})`;
  });

  return {
    shadowStyle,
  };
}

